import { render, staticRenderFns } from "./AcademicSession.vue?vue&type=template&id=0140b897"
import script from "./AcademicSession.vue?vue&type=script&lang=js"
export * from "./AcademicSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports